import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <Header />
      
      {/* Hero Section */}
      <section className="about-hero-section">
        <div className="page-container">
          <div className="about-hero-content">
            <h1 className="about-hero-title">About SymbolFly</h1>
            <p className="about-hero-subtitle">
              Your premium flight booking experience in Nigeria and beyond.
            </p>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="our-story-section">
        <div className="page-container">
          <div className="story-card">
            <div className="story-header">
              <div className="story-icon">✈️</div>
              <h2 className="story-title">Our Story</h2>
            </div>
            <div className="story-content">
              <p className="story-text">
                SymbolFly was founded with a simple yet powerful vision: to transform the way Nigerians book flights. 
                We recognized that the existing flight booking experience was often complicated, unreliable, and didn't 
                cater to the unique needs of Nigerian travelers.
              </p>
              <p className="story-text">
                Our journey began with a commitment to premium service, cutting-edge technology, and a deep understanding 
                of the Nigerian market. We've built a platform that combines luxury design with practical functionality, 
                ensuring that every traveler—whether flying domestically or internationally—enjoys a seamless booking experience.
              </p>
              <p className="story-text">
                Today, SymbolFly stands as a trusted partner for thousands of travelers, offering reliable payment options, 
                instant confirmations, and 24/7 support tailored specifically for the Nigerian market. We're not just a 
                booking platform; we're your gateway to the world.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section">
        <div className="page-container">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <div className="mission-icon">🎯</div>
              <h2 className="mission-title">Our Mission</h2>
              <p className="mission-text">
                To provide seamless, modern, and premium flight booking experiences tailored for Nigerian travelers. 
                We strive to make air travel accessible, reliable, and enjoyable for everyone.
              </p>
            </div>

            <div className="vision-card">
              <div className="vision-icon">🌟</div>
              <h2 className="vision-title">Our Vision</h2>
              <p className="vision-text">
                To become the most trusted and luxurious flight booking brand in Africa and beyond. We envision a future 
                where every Nigerian traveler has access to premium booking services that match international standards.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="page-container">
          <div className="section-header">
            <h2 className="section-title">Why Choose SymbolFly</h2>
            <p className="section-subtitle">
              Experience the difference of premium flight booking
            </p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">💳</div>
              <h3 className="feature-title">Reliable Payments</h3>
              <p className="feature-text">
                Paystack, Flutterwave, Bank Transfers, USSD—all major Nigerian payment methods supported. 
                Secure, fast, and trusted by thousands.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📧</div>
              <h3 className="feature-title">Instant E-Tickets</h3>
              <p className="feature-text">
                Get your flight confirmation and e-ticket immediately after booking. No waiting, no delays—just instant peace of mind.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">✨</div>
              <h3 className="feature-title">Luxury UX</h3>
              <p className="feature-text">
                Premium design meets intuitive functionality. Our Bright Nimbus interface ensures every interaction 
                feels smooth, modern, and delightful.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3 className="feature-title">24/7 Support</h3>
              <p className="feature-text">
                Nigerian-focused customer care available around the clock. Our support team understands your needs 
                and is always ready to help.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="page-container">
          <div className="section-header">
            <h2 className="section-title">Our Team</h2>
            <p className="section-subtitle">
              The people behind SymbolFly's success
            </p>
          </div>

          <div className="team-grid">
            <div className="team-card">
              <div className="team-photo">
                <div className="team-photo-placeholder">👤</div>
              </div>
              <h3 className="team-name">Adebayo Ogunleye</h3>
              <p className="team-role">Founder & CEO</p>
              <p className="team-bio">
                Passionate about transforming travel experiences for Nigerian travelers.
              </p>
            </div>

            <div className="team-card">
              <div className="team-photo">
                <div className="team-photo-placeholder">👤</div>
              </div>
              <h3 className="team-name">Chioma Nwosu</h3>
              <p className="team-role">Head of Operations</p>
              <p className="team-bio">
                Ensuring seamless operations and exceptional customer service.
              </p>
            </div>

            <div className="team-card">
              <div className="team-photo">
                <div className="team-photo-placeholder">👤</div>
              </div>
              <h3 className="team-name">Emeka Okoro</h3>
              <p className="team-role">Chief Technology Officer</p>
              <p className="team-bio">
                Building innovative solutions for modern flight booking.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;

